import React from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { ThreeCircles } from "react-loader-spinner";
import Modal from "react-bootstrap/Modal";
import { getFromLS } from "../../utils/storage";
import './NoAccess.css'

export function NoAccessPopup(props) {
    const username = getFromLS("username")
    console.log("No access to " + props.featurename + " feature.")
    return (
        <Col className="card-container-noaccess">
            <Card className="noaccess">
                <span className="noaccess-header" style={{ color: "var(--text_color)", fontWeight: "700" }}> Hello {username}! &nbsp; &nbsp;</span>
                <Card.Body className="message">
                    {props.featurename == "Super Admin"
                        ?
                        <p>What are you trying to do? You are not supposed to be here.<br /> <b>Shooo Shooo GO AWAY!</b></p>
                        :
                        <p>Unfortunately, you don't have access to <b><i>{props.featurename}</i></b> as of now. Please upgrade your subscription or contact support for further details.</p>}
                </Card.Body>
                <a href="/dashboard" style={{ textAlign: "right" }}>Go home</a>
            </Card>
        </Col>
    );
}